import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './src/App';
import { ToastProvider } from './src/contexts/ToastContext';
import { GAME_VERSION_NUMBER } from './src/version';
import { requestPersistentStorage } from './src/services/PersistentStorageService';
import './src/index.css';

import * as Sentry from "@sentry/react";

// Inject environment variables into window for AdSense script (in index.html)
if (typeof window !== 'undefined') {
    (window as any).__GOOGLE_ADS_PUBLISHER_ID__ = import.meta.env.VITE_GOOGLE_ADS_PUBLISHER_ID || 'pub-2689014507104443';
    (window as any).__GOOGLE_ADS_CUSTOMER_ID__ = import.meta.env.VITE_GOOGLE_ADS_CUSTOMER_ID || '0';
}

// Request persistent storage on app startup for iOS PWA offline support
requestPersistentStorage();

Sentry.init({
  dsn: "https://9d537affd7c5c052e0e7eb2260b54134@o60423.ingest.us.sentry.io/4510185140977664",
  tunnel: "/api/sentry-tunnel",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Release tracking for source map handling
  release: import.meta.env.VITE_APP_VERSION || process.env.npm_package_version || '0.0.0',
  environment: import.meta.env.MODE || 'production',
   integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    })
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Capture game version with all events
  beforeSend(event) {
    // Add game version to all events for easy filtering and debugging
    if (!event.tags) {
      event.tags = {};
    }
    event.tags.game_version = GAME_VERSION_NUMBER;
    return event;
  }
});

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(
        <ToastProvider>
            <App />
        </ToastProvider>
    );
}
